import React from 'react'
import { Link, useLocation } from 'react-router-dom'

// Sidebar entry in the studio style (plans/REDESIGN.md, phase 2). Active on its own page
// and the pages under it; `match` adds other sections it covers (Team covers Roles).
// Agency sidebar colours apply through the --lj-nav-* tokens.
export const isActivePath = (pathname, paths) =>
  paths.some((p) => p && (pathname === p || (p !== '/' && pathname.startsWith(p.replace(/\/$/, '') + '/'))))

function NavItem({ label, path, icon, match = [], onClick }) {
  const { pathname } = useLocation()
  const active = isActivePath(pathname, [path, ...match])

  return (
    <li>
      <Link
        to={path}
        onClick={onClick}
        aria-current={active ? 'page' : undefined}
        className={`group flex items-center gap-3 min-h-[40px] px-3 rounded-control text-[13px] transition-colors duration-ui ease-studio focus-visible:outline focus-visible:outline-[3px] focus-visible:outline-offset-2 focus-visible:outline-focus ${
          active ? 'bg-nav-active text-nav-active-ink font-semibold' : 'text-nav-ink font-medium hover:bg-action-wash hover:text-ink'
        }`}
      >
        <span className={`flex w-5 h-5 items-center justify-center ${active ? '' : 'opacity-80 group-hover:opacity-100'}`}>{icon}</span>
        <span className='truncate'>{label}</span>
      </Link>
    </li>
  )
}

export default NavItem
